<template lang="pug">
.zoom-container
  img.zoom-img(ref="img" alt="")
</template>
<script setup lang="ts">
import { onMounted, useTemplateRef } from 'vue'

const emit = defineEmits<{ (e: 'loaded', img: HTMLImageElement): void }>()

const imgRef = useTemplateRef<HTMLImageElement>('img')

onMounted(() => {
  emit('loaded', imgRef.value!)
})
</script>
<style lang="scss" scoped>
  .zoom-container {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .zoom-img {
    object-fit: contain;
    width: 100%;
    height: 100%;
  }
</style>
